import uuid from 'uuid/v4';
import { PrivateMemberWrite } from '@/api/types/private-room';

export interface PrivateRoomOperation {
  id: number;
  uid: number;
  kind: 'join' | 'leave' | 'autoRenew' | 'prepay' | 'moderate';
  userId?: number;
  body: PrivateMemberWrite;
}
export const newPrivateRoomOperation = (params: Omit<PrivateRoomOperation, 'body'> & { body: Omit<PrivateMemberWrite, 'requestId'> }): PrivateRoomOperation =>
  ({ ...params, body: { ...params.body, requestId: uuid() } });
export const privateOperationKey = (uid: number, id: number): string => `private-room-operation/${uid}/${id}`;
export const isDefinitePrivateFailure = (error): boolean =>
  !!(error && error.response && error.response.errcode >= 400 && error.response.errcode < 500);
